import { AES, enc } from 'crypto-js';
import * as url from "../store/constant/Endpoints";
import { MdHome } from "react-icons/md";
import { HiUsers } from "react-icons/hi2";

// Icons for menu
const icons = {
    navigation: MdHome,
    AllTenants: HiUsers
};

// Decrypt user data from localStorage
let permissionUser = localStorage.getItem('data');
let decryptedData = null;
if (permissionUser) {
    try {
        decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(enc.Utf8);
    } catch (error) {
        console.log(error, "decryption error");
    }
}
const permissions = decryptedData ? JSON.parse(decryptedData)?.permissions : null;
const allowedPermissions = permissions && permissions.length !== 0 ? permissions.map(p => p?.permission) : [];

// Check permission function
const permissionsAccessFunction = (brand) => {
    return allowedPermissions && allowedPermissions.length !== 0 && allowedPermissions.some(permission => permission.includes(brand));
};

// ==============================|| MENU ITEMS - All Tenants ||============================== //

const allTenants = (true) ? {
    id: 'all-tenants-group',
    title: 'Tenant Management',
    icon: icons.navigation,
    type: 'group',
    children: [
        (true) ? {
            id: 'all-tenants',
            title: 'All Tenants',
            type: 'item',
            url: '/tenants/all-tenants',
            icon: icons.AllTenants,
            breadcrumbs: true
        } : null,
        (true) ? {
            id: 'add-tenant',
            title: 'Add Tenant',
            type: 'item',
            url: '/tenants/add-tenant',
            icon: icons.AllTenants,
            breadcrumbs: true
        } : null,
    ].filter(Boolean)
} : null;

export default allTenants;